import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ThermostatInfo } from '../ThermostatInfo';
import './ThermostatReauthentication.css';
import { ConnectedThermostatAuthentication } from '../ThermostatAuthentication';
import { PrimaryButton } from '../../../PrimaryButton';
import { Modal } from '../../../Modal';
import { Notification } from '../../../Notification';

export class ThermostatReauthentication extends Component {
  state = {
    showInfoPage: true,
    success: false,
  };

  closeInfo = () => {
    this.setState((state) => ({
      ...state,
      showInfoPage: false,
    }));
  };

  handleSuccess = () => {
    this.setState((state) => ({
      ...state,
      success: true,
    }));
  };

  renderSuccess() {
    const { onRequestClose } = this.props;

    return (
      <div className="thermostat-reauthentication">
        <div className="thermostat-reauthentication__text-group">
          <div className="thermostat-reauthentication__title-text">Finished!</div>
        </div>
        <div className="thermostat-reauthentication__success">
          <Notification message={'Thermostat added successfully.'} type="success" />
        </div>
        <div className="thermostat-reauthentication__primary-button-wrapper">
          <PrimaryButton icon="back-icon" label="View Thermostats" onClick={onRequestClose} fullWidth={true} />
        </div>
      </div>
    );
  }

  render() {
    const { showInfoPage, success } = this.state;
    const {
      currentThermostat,
      selectedBuilding,
      onRequestClose,
      currentThermostat: { uid_hash: uid },
    } = this.props;

    return (
      <React.Fragment>
        {showInfoPage ? (
          <ThermostatInfo
            currentBuilding={selectedBuilding}
            currentThermostat={currentThermostat}
            onClose={onRequestClose}
            mainButtonOnClick={this.closeInfo}
          />
        ) : null}

        <Modal>
          <div className="thermostat-reauthentication-overlay">
            <div className="thermostat-reauthentication-modal">
              <div className="thermostat-reauthentication__title">
                <div className="thermostat-reauthentication__back-button-div" />
                <div className="thermostat-reauthentication__title-div">
                  <div className="thermostat-reauthentication__title-text">Reauthenticate</div>
                </div>
                <div className="thermostat-reauthentication__close-button-div">
                  <input className="thermostat-reauthentication__close-button" type="button" onClick={onRequestClose} />
                </div>
              </div>
              {success ? (
                this.renderSuccess()
              ) : (
                <ConnectedThermostatAuthentication reauthenticate={true} uid={uid} onSuccess={this.handleSuccess} />
              )}
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

ThermostatReauthentication.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  currentThermostat: PropTypes.shape({
    mode: PropTypes.string,
    state: PropTypes.string,
    uid_hash: PropTypes.string,
    fan_mode: PropTypes.string,
    direction: PropTypes.string,
    is_occupied: PropTypes.bool,
    unit_number: PropTypes.string,
    display_name: PropTypes.string,
    floor_number: PropTypes.number,
    serial_number: PropTypes.string,
    building_slug: PropTypes.string,
    is_fan_running: PropTypes.bool,
    thermostat_type: PropTypes.string,
    building_section: PropTypes.string,
    temperature_unit: PropTypes.string,
    connection_state: PropTypes.string,
    target_temperature: PropTypes.string,
    ambient_temperature: PropTypes.string,
    connection_timestamp: PropTypes.string,
    target_temperature_low: PropTypes.string,
    target_temperature_high: PropTypes.string,
    disconnection_timestamp: PropTypes.string,
    status_update_timestamp: PropTypes.string,
    temperature_satisfaction: PropTypes.string,
  }).isRequired,
  selectedBuilding: PropTypes.string,
};
